import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import apiurl from './apiurl';
import axios from 'axios';
import swal from 'sweetalert';
import Opinie_wyb from './Opinie_wyb';
import NavBar from './NavBar';



export default class Zak_opiniowanie extends React.Component {
constructor(props) {
  super(props);    
  this.state = {
    token: sessionStorage.getItem('token'),
    uwaga: "",
    data: this.dzis(),

  }

  this.handledChange = this.handledChange.bind(this);

}


onChange = (e) => { this.setState({  [e.target.name]: e.target.value }); }

post = () => {
axios.post(apiurl+"api/Opinie/Post1",
    {idOpinia: this.props.idopini, idUchwaly: this.props.iduchwaly , rok: this.props.rok, uwaga: this.state.uwaga, dataZamkniecia: this.state.data },
    {headers : {'Content-Type': 'application/json' , 'Authorization' : "Bearer " + this.state.token } })
    .then(res => {
      console.log('ok')
    })
.catch(error => { swal(error.response.data);  });
}

dzis() {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  return today = yyyy + '-' + mm + '-' + dd;
}

handledChange(event) { this.setState({ [event.target.name]: event.target.value }) }

render() {
  let { data , status } = this.state;
return (
<React.Fragment>
<div className="container-fluid">
<h1>Zakończ opiniowanie</h1>
<hr />

<div className="d-flex flex-row">
<div class="flex-column w-100">
<span>Uzasadnienie:</span>
{status === "P" ? (<textarea class="form-control" name="uwaga" onChange={this.onChange.bind(this)} rows="3" disabled></textarea>) : (<textarea class="form-control" name="uwaga" onChange={this.onChange.bind(this)} rows="3"></textarea>)}
</div>
</div>

<div className="d-flex flex-row mt-4">
<div class="flex-column w-100">
<label>Data zakończenia: </label><input type="date" class="form-control col-3" name="data" value={data}  onChange={this.handledChange}></input>
</div>
</div>

<div className="d-flex flex-row">
<div class="flex-column w-100">
<button  onClick={() => {
  swal({
    title: "Czy napewno chcesz zapisać?",
    text: "Wydziały, które nie zostały zaopiniowane otrzymają status: Zignorowany",
    buttons: {
    cancel: "Anuluj",
    catch: {
      text: "Zapisz",
      value: "willDelete",} 
    },
    dangerMode: true,
  })
  .then((willDelete) => {
    if (willDelete) {
      this.post();
    } else {
      
    }
  });
}} type="button" class="btn btn-light float-right m-2" >Zapisz</button>
</div>
</div>

</div>
</React.Fragment>
);
}
}


